import base64url from 'base64url'

import API, { initApiUrl } from '@/store/api'

initApiUrl('')

const user = {
  state: {
    userEmail: '',
    userName: '',

    deviceId: '',
    ref: '',
    appVersion: undefined,

    authorization: {
      sessionId: '',
      accessToken: '',
      key: ''
    },

    baeminMemberId: '',
    baeminMemberNo: '',
    baeminShopNo: '',
    isSign: true,

    userBaedal: ''
  },
  mutations: {
    setAccessToken: (state, token) => {
      state.authorization.accessToken = token
    },
    setSessionId: (state, sessionId) => {
      state.authorization.sessionId = sessionId
    },
    setSignedUser: (state, isSign) => {
      state.isSign = isSign
    },
    setKey: (state, key) => {
      state.authorization.key = key
    },
    setDeviceId: (state, deviceId) => {
      state.deviceId = deviceId
    },
    setBaeminMemberId: (state, baeminMemberId) => {
      state.baeminMemberId = baeminMemberId
    },
    setBaeminMemberNo: (state, baeminMemberNo) => {
      state.baeminMemberNo = baeminMemberNo
    },
    setBaeminShopNo: (state, baeminShopNo) => {
      state.baeminShopNo = baeminShopNo
    },
    setRef: (state, ref) => {
      state.ref = ref
    },
    setAppVersion: (state, appVersion) => {
      state.appVersion = appVersion
    },
    setUserName: (state, name) => {
      state.userName = name
    },
    setUserEmail: (state, email) => {
      // 유효성 규칙에 맞지 않은 email이 들어올 수 있음
      state.userEmail = email
    },

    setByOrderSheet: (state, payload) => {
      const {
        accessToken: token,
        deviceId,
        memberEmail: userEmail,
        memberName: userName,
        memberNumber: baeminMemberNo,
        sessionId,
        signedUser,
        userBaedal: key
      } = payload

      // state.authorization.accessToken = token // ""
      state.authorization.sessionId = sessionId // "E29003CF0796"
      state.authorization.key = key // "tZeAAnVOw8tiERHyCjNGipgDSe9vt7m2OU3+1XUOWnyyR
      state.signedUser = signedUser // true
      state.userName = userName // "마광휘"
      state.userEmail = userEmail // "vallista@woowahan.com"
      state.deviceId = deviceId // "OPUDF73D60AE-8E44-481F-9C7C-14834ECE4584"
      state.baeminMemberNo = baeminMemberNo // "190919000008"
    },

    setUserBaedal: (state, userBaedal) => {
      state.userBaedal = userBaedal
    }
  },
  getters: {
    userEmail: (state) => state.userEmail,
    userName: (state) => state.userName,
    deviceId: (state) => state.deviceId,
    appVersion: (state) => state.appVersion,
    sessionId: (state) => state.authorization.sessionId,
    accessToken: (state) => state.authorization.accessToken,
    key: (state) => state.authorization.key,
    isSign: (state) => state.isSign,
    ref: (state) => state.ref,
    baeminMemberId: (state) => state.baeminMemberId,
    baeminMemberNo: (state) => state.baeminMemberNo,
    baeminShopNo: (state) => state.baeminShopNo,

    userBaedal: (state) => state.userBaedal
  },
  actions: {
    initHeaderValues: ({ commit }, header) => {
      if (header.ref) commit('setRef', header.ref)
      if (header.sessionId) commit('setSessionId', header.sessionId)
      if (header.token) commit('setAccessToken', header.token)
      if (header.key) commit('setKey', base64url.decode(header.key, 'utf-8'))
      if (header.baeminShopNo) commit('setBaeminShopNo', header.baeminShopNo)
      if (header.appVersion) commit('setAppVersion', header.appVersion)
    },

    loadMemberByKey: async ({ commit, rootState }) => {
      try {
        const userBaedal = rootState.user.authorization.key
        if (!userBaedal) return
        const option = {
          headers: {
            'USER-BAEDAL': userBaedal
          }
        }

        // TODO check src/views/my/order/OrderHistory.vue:85
        const { code, result } = await API.get('/v1/members/app-log/member', option)
        if (code !== '200') return result

        commit('setDeviceId', result.deviceId)
        commit('setBaeminMemberId', result.memberId)
        commit('setBaeminMemberNo', result.memberNumber)

        return result
      } catch (error) {
        return error.response.data.result
      }
    }
  }
}

export default user
